import { Text } from 'components/Text';
import { React, useState } from 'libs/react';
import { FormInputPicker } from 'components/form/FormInputPicker';
import { ContactListQuery } from 'graphql/Contact/queries/ContactListQuery';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { Button } from 'components/Button';
import { ContactQuickAddMenu } from 'modules/contact/menus/ContactQuickAddMenu';
import { ContactQuickEditMenu } from 'modules/contact/menus/ContactQuickEditMenu';
import { Phone } from 'components/Phone';
import { ContactListExternalQuery } from 'graphql/Contact/queries/ContactListExternalQuery';
import './DealContactPanel.scss';
/**
 * @component DealContactPanel
 * @since 1.0.0
 */
export function DealContactPanel(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    const { style, deal } = Object.assign({ style: 'normal' }, props);
    const { updateDealField } = useDealConfiguratorContext();
    const [contactQuickAddOpen, setContactQuickAddOpen] = useState(false);
    const [contactEditOpen, setContactEditOpen] = useState(false);
    /**
     * @function onSelect
     * @since 1.0.0
     * @hidden
     */
    const onSelect = (selection) => {
        updateDealField('contact', selection, 'object');
        if (selection.location) {
            updateDealField('billTo', selection.location, 'object');
            updateDealField('shipTo', selection.location, 'object');
        }
        else {
            updateDealField('billTo', undefined, 'object');
            updateDealField('shipTo', undefined, 'object');
        }
        if (selection.client) {
            updateDealField('client', selection.client, 'object');
            if (selection.client.primaryLocation) {
                updateDealField('billTo', selection.client.primaryLocation, 'object');
                updateDealField('shipTo', selection.client.primaryLocation, 'object');
            }
        }
        else {
            updateDealField('client', undefined, 'object');
        }
    };
    /**
     * @function onPress
     * @since 1.0.0
     * @hidden
     */
    const onPress = () => {
        updateDealField('contact', undefined, 'undefined');
    };
    /**
     * @function onContactQuickAddClose
     * @since 1.0.0
     * @hidden
     */
    const onContactQuickAddClose = () => {
        setContactQuickAddOpen(false);
    };
    /**
     * @function onContactEditOpen
     * @since 1.0.0
     * @hidden
     */
    const onContactEditOpen = () => {
        setContactEditOpen(true);
    };
    /**
     * @function onContactEditClose
     * @since 1.0.0
     * @hidden
     */
    const onContactEditClose = () => {
        setContactEditOpen(false);
    };
    /**
     * @function onContactUpdateDone
     * @since 1.0.0
     * @hidden
     */
    const onContactUpdateDone = (updatedContact) => {
        updateDealField('contact', updatedContact, 'object');
        // Update billTo and shipTo based on contact location or client's primary location
        if (updatedContact.location) {
            updateDealField('billTo', updatedContact.location, 'object');
            updateDealField('shipTo', updatedContact.location, 'object');
        }
        else {
            updateDealField('billTo', undefined, 'object');
            updateDealField('shipTo', undefined, 'object');
        }
        if (updatedContact.client) {
            updateDealField('client', updatedContact.client, 'object');
            if (updatedContact.client.primaryLocation) {
                updateDealField('billTo', updatedContact.client.primaryLocation, 'object');
                updateDealField('shipTo', updatedContact.client.primaryLocation, 'object');
            }
        }
        else {
            updateDealField('client', undefined, 'object');
        }
    };
    return (React.createElement("div", { className: "deal-contact-panel" },
        React.createElement("div", { className: "deal-contact-panel-container" }, !deal.contact ? (React.createElement(FormInputPicker, { placeholder: `${t('Select or create a contact')}`, createLabel: t('Create a contact'), noResultsLabel: t('No contact found.'), entity: "contact", query: ContactListQuery, externalQuery: ContactListExternalQuery, objectType: "contacts", externalObjectType: "contactsExternal", onSelect: (value) => {
                onSelect(value);
            }, format: (value) => {
                var _a, _b, _c;
                return ({
                    id: value.id,
                    title: ((_a = value.fullname) !== null && _a !== void 0 ? _a : value.name) +
                        (((_b = value.primaryEmail) === null || _b === void 0 ? void 0 : _b.email)
                            ? ' (' + ((_c = value.primaryEmail) === null || _c === void 0 ? void 0 : _c.email) + ')'
                            : '') +
                        (value.client ? ' - ' + value.client.name : ''),
                    infos: '',
                    asset: value.asset
                });
            }, creatable: true, onCreate: () => {
                setContactQuickAddOpen(true);
            }, singlePick: true })) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "deal-contact-panel-container-button" },
                React.createElement(Text, { value: (_a = deal.contact) === null || _a === void 0 ? void 0 : _a.fullname }),
                React.createElement("div", { className: "deal-contact-panel-buttons" },
                    React.createElement(Button, { style: "picto", picto: "pen-to-square", size: "small", onPress: onContactEditOpen, className: "deal-contact-panel-button" }),
                    React.createElement(Button, { style: "picto", picto: "xmark", size: "small", onPress: onPress, className: "deal-contact-panel-button" }))),
            React.createElement(Text, { value: ((_c = (_b = deal.contact) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.address)
                    ? ((_e = (_d = deal.contact) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.address) +
                        ', ' +
                        ((_g = (_f = deal.contact) === null || _f === void 0 ? void 0 : _f.location) === null || _g === void 0 ? void 0 : _g.city) +
                        ', ' +
                        ((_j = (_h = deal.contact) === null || _h === void 0 ? void 0 : _h.location) === null || _j === void 0 ? void 0 : _j.postalcode)
                    : '' }),
            React.createElement(Text, { value: ((_l = (_k = deal.contact) === null || _k === void 0 ? void 0 : _k.location) === null || _l === void 0 ? void 0 : _l.primaryEmail)
                    ? (_o = (_m = deal.contact) === null || _m === void 0 ? void 0 : _m.location) === null || _o === void 0 ? void 0 : _o.primaryEmail.email
                    : ((_q = (_p = deal.contact.primaryEmail) === null || _p === void 0 ? void 0 : _p.email) !== null && _q !== void 0 ? _q : '') }),
            React.createElement(Phone, { value: ((_s = (_r = deal.contact) === null || _r === void 0 ? void 0 : _r.location) === null || _s === void 0 ? void 0 : _s.primaryPhone)
                    ? (_u = (_t = deal.contact) === null || _t === void 0 ? void 0 : _t.location) === null || _u === void 0 ? void 0 : _u.primaryPhone.phone
                    : ((_w = (_v = deal.contact.primaryPhone) === null || _v === void 0 ? void 0 : _v.phone) !== null && _w !== void 0 ? _w : '') })))),
        contactQuickAddOpen && (React.createElement(ContactQuickAddMenu, { open: contactQuickAddOpen, onClose: onContactQuickAddClose, hideButton: true, redirect: false, onContactCreateDone: onSelect, isEndClient: true })),
        contactEditOpen && deal.contact && (React.createElement(ContactQuickEditMenu, { contact: deal.contact, open: contactEditOpen, onClose: onContactEditClose, hideButton: true, onContactUpdateDone: onContactUpdateDone, isEndClient: true, style: style }))));
}
